import { FC } from 'react'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { PrivateAPIsFieldProps } from '../APIManager.d'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'

const PrivateAPIsField: FC<PrivateAPIsFieldProps> = ({
    field,
    type,
    config,
    formikProps,
    privateAPIs,
    setPrivateAPIs,
    originalPrivateAPIs,
    setOriginalPrivateAPIs,
}) => {
    const { values, errors, touched, handleChange, setFieldValue } = formikProps
    const fieldName = type + '-' + field.id

    return (
        <Row>
            <Col xs={12}>
                <InputGroup className="w-100">
                    <Form.Control
                        as={config.type === 'textarea' ? 'textarea' : 'input'}
                        name={`${type}-${field.id}`}
                        size="sm"
                        value={values[fieldName] || ''}
                        onChange={handleChange}
                        placeholder={`Enter ${config.singleLabel}`}
                        className={`small ${
                            errors[fieldName] && touched[fieldName]
                                ? 'is-invalid'
                                : ''
                        }`}
                    />
                    <Button
                        variant="transparent"
                        className="btn-xs border-0"
                        onClick={(e) => {
                            setFieldValue(fieldName, '')
                            setPrivateAPIs(privateAPIs)
                            setOriginalPrivateAPIs((prevState) => {
                                return {
                                    ...prevState,
                                    [type]: originalPrivateAPIs[type].filter(
                                        (x) => x.id !== field.id
                                    ),
                                }
                            })
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            className="text-danger"
                        />
                    </Button>
                </InputGroup>
            </Col>
        </Row>
    )
}

export default PrivateAPIsField
